export default __webpack_public_path__ + "static/media/@laissaorsano.f2d54271.jpg";